var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hidden"},[(_vm.isVideo)?_c('video',{ref:"videoElement",staticClass:"videoBackground",attrs:{"loop":"","muted":"","src":_vm.url,"crossorigin":"anonymous"},domProps:{"muted":true}}):_vm._e(),(!_vm.isVideo)?_c('div',{staticClass:"imageBackground",class:{
      animate: _vm.animate,
      noAnimation: _vm.stopAnimationWhenNotPlaying && !_vm.animate,
    },style:('background-image:url(' + _vm.url + ');')}):_vm._e(),(_vm.mask !== 'none')?_c('div',{staticClass:"overlay",class:_vm.mask}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }